import React, { useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

function Portal(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "reach-portal" : _ref$type;
  var mountNode = useRef(null);
  var portalNode = useRef(null);

  var _useState = useState(),
      forceUpdate = _useState[1];

  useLayoutEffect(function () {
    // It's possible that the content we are portal has, itself, been portaled.
    // In that case, it's important to append to the correct document element.
    var ownerDocument = mountNode.current.ownerDocument;
    portalNode.current = ownerDocument.createElement(type);
    ownerDocument.body.appendChild(portalNode.current);
    forceUpdate({});
    return function () {
      portalNode.current.ownerDocument.body.removeChild(portalNode.current);
    };
  }, [type]);
  return portalNode.current ? createPortal(children, portalNode.current) : React.createElement("div", {
    ref: mountNode
  });
}

Portal.displayName = "Portal";
export default Portal;